module.exports = __webpack_public_path__ + "static/ram_racing-e58390d7346be69c31f55fdd8faebd59.jpg";